import { IPowerbarStoreModule, registerAdapter, unregisterAdapter } from '../utils'
import { ISearchState } from './types'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import state from './state'

const SearchState: IPowerbarStoreModule<ISearchState, any> = {
  name: 'SearchState',
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
SearchState.register = registerAdapter(SearchState);
SearchState.unregister = unregisterAdapter(SearchState);

export default SearchState

